import { JetView } from 'webix-jet'; // Importing JetView from the webix-jet library for creating views
import { allpayments } from 'models/allpayments'; // Importing allpayments model for data handling
import { devConfig } from 'config/config'; // Importing development configuration settings

/**
 * Class representing a view for the deposit report table.
 * @extends JetView
 */
export default class tableDepositReportView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        // Retrieve the localization service and its translation function
        const _ = this.app.getService('locale')._;
        // Define the date format using the application's configuration
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat);
        // Sample data array containing request information
        const data = [
            {
                Id: '0101', // Unique identifier for the request
                Agent: 'Agente 1', // Name of the agent
                Date: '2019-04-06 23:27:16', // Date of the request
                Description: 'Freebet para los jugadores', // Description of the request
                Type: '2', // Type of request (Freebet)
                Budget: '500', // Budget associated with the request
                State: 'P', // Current state of the request (Pending)
            },
        ];
        // Preserve the context of 'this' for use in event handlers
        var vthis = this;
        return {
            rows: [
                {
                    id: 'preloader', // ID for the preloader element
                    cols: [
                        {
                            view: 'datatable', // Define a datatable view
                            id: 'datatable', // ID for the datatable
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            select: true, // Enable row selection
                            height: screen.width < 500 ? 405 : 0, // Set height based on screen width
                            columns: [
                                {
                                    id: 'Id', // Column ID
                                    header: 'Id', // Column header
                                    width: 80, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'ActionTittle', // Column ID for action buttons
                                    header: '', // No header for this column
                                    width: 70, // Column width
                                    height: 25, // Height of the column
                                    tooltip: _('Acción'), // Tooltip text for the column
                                    template: function (obj) {
                                        // Template function for rendering action buttons
                                        if (obj.State == 'P') {
                                            // Check if the state is Pending
                                            if (
                                                devConfig.getPermAction('agentRequestsAgentApprove', 'Approve') // Check for approval permission
                                            ) {
                                                // Return HTML for approve and refuse buttons
                                                return "<span placeholder='Aprobar' class='webix_icon wxi-close approve prm-agentRequestsAgentApprove'></span><span class='webix_icon wxi-close torefuse prm-agentRequestsAgentApprove'></span>";
                                            } else {
                                                return ''; // No buttons if permission is not granted
                                            }
                                        }
                                    },
                                },
                                {
                                    id: 'Agent', // Column ID for agent name
                                    header: 'Agente', // Column header
                                    width: 200, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Date', // Column ID for date
                                    header: _('Fecha Creación'), // Column header with localization
                                    fillspace: 0, // No fill space
                                    minWidth: 0, // Minimum width
                                    width: 200, // Column width
                                    sort: 'text', // Sorting type
                                    format: dateFormat, // Date formatting function
                                },
                                {
                                    id: 'Description', // Column ID for description
                                    header: _('Descripción'), // Column header with localization
                                    width: 200, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Type', // Column ID for type
                                    header: _('Tipo'), // Column header with localization
                                    options: [
                                        // Options for the type column
                                        { id: '0', value: _('Bono Deposito') }, // Deposit bonus
                                        {
                                            id: '1',
                                            value: _('Bono No Deposito'), // No deposit bonus
                                        },
                                        { id: '2', value: _('Freebet') }, // Freebet
                                    ],
                                },
                                {
                                    id: 'Budget', // Column ID for budget
                                    header: _('Presupuesto'), // Column header with localization
                                    format: webix.i18n.priceFormat, // Formatting function for price
                                    exportType: 'number', // Export type for the column
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'State', // Column ID for state
                                    header: _('Estado'), // Column header with localization
                                    options: [
                                        // Options for the state column
                                        { id: '', value: _('None') }, // No state
                                        { id: 'A', value: _('Aprobado') }, // Approved
                                        { id: 'R', value: _('Rechazado') }, // Rejected
                                        { id: 'P', value: _('Pendiente') }, // Pending
                                    ],
                                },
                            ],
                            onClick: {
                                // Event handlers for click events
                                approve: function (euv, id) {
                                    // Handler for approve button click
                                    var item = this.getItem(id); // Get the clicked item
                                    vthis.app.callEvent('requestsApprove:id', [
                                        // Trigger approve event
                                        item,
                                    ]);
                                    $$('responts-request').show(); // Show response request dialog
                                },
                                torefuse: function (euv, id) {
                                    // Handler for refuse button click
                                    var item = this.getItem(id); // Get the clicked item
                                    vthis.app.callEvent('requestsTorefuse:id', [
                                        // Trigger refuse event
                                        item,
                                    ]);
                                    $$('responts-request').show(); // Show response request dialog
                                },
                            },
                            math: true, // Enable mathematical operations
                            loadahead: devConfig.getDefaultDataFetch(), // Set data fetch configuration
                            pager: 'pagerA', // ID for the pager component
                            data: data, // Data source for the datatable
                            url: devConfig.geturlApi() + 'es/GetRequestsAgent', // API endpoint for data retrieval
                        },
                    ],
                },
            ],
        }; // Placeholder for the configuration content
    }

    /**
     * Initializes the view and its components.
     * @param {Object} grid - The grid component to be initialized.
     */
    init(grid) {
        // Get the localization service from the app
        const _ = this.app.getService('locale')._;
        // Reference to the data table component
        grid = $$('datatable');
        // Store the URL for data loading
        var url = grid.data.url;
        // Initialize filter string
        var filter = '';
        // Variable to hold request IDs
        var idRequests;
        // Variable to hold action type
        var action;
        // Preserve the context of 'this'
        var vthis = this;

        // Event listener for filtering requests
        this.on(this.app, 'requestsAgent:filter', (filterData) => {
            // Convert filter data object to an array of entries
            var object = Object.entries(filterData);
            // Initialize filter string
            var string1 = '';
            // Iterate through filter entries
            for (var i = 0; i < object.length; i++) {
                // Check if the value is not an object and not empty
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Handle date range filtering
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - ');
                        string1 = string1 + '&dateFrom=' + date[0];
                        string1 = string1 + '&dateTo=' + date[1];
                    } else {
                        // Append other filter parameters
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1];
                    }
                } else {
                    // Handle object type filter values
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]);
                        // Iterate through nested filter entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                // Handle start date
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]);
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom;
                                } else {
                                    // Handle end date
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]);
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            // Clear existing data in the grid
            grid.clearAll();
            // Load new data with applied filters
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1);
            // Update the filter variable
            filter = string1;
        });

        // Event listener for sorting the data table
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            // Load sorted data based on the selected column and direction
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir);
        });

        // Create a popup window for responding to requests
        var popup = webix.ui({
            view: 'window',
            id: 'responts-request',
            head: {
                view: 'toolbar',
                cols: [
                    {
                        view: 'label',
                        label: _('Responder Solicitud'),
                        id: 'lblPopup',
                    },
                    {
                        view: 'icon',
                        icon: 'wxi-close',
                        click: function () {
                            // Close the popup window
                            this.getTopParentView().hide();
                        },
                    },
                ],
            },
            position: 'center',
            modal: true,
            body: {
                view: 'form',
                id: 'addResponts',
                elements: [
                    {
                        view: 'textarea',
                        name: 'Responts',
                        placeholder: _('Respuesta'),
                        required: true,
                        invalidMessage: _('Campo Requerido'),
                    },
                    {
                        cols: [
                            {
                                view: 'button',
                                value: 'Cancelar',
                                click: function () {
                                    // Close the popup and reset form values
                                    this.getTopParentView().hide();
                                    $$('addResponts').setValues($$('addResponts').getCleanValues());
                                },
                            },
                            {
                                view: 'button',
                                type: 'form',
                                id: 'buttonResponts',
                                value: _('Guardar'),
                                click: function ($e) {
                                    // Get values from the response form
                                    var values = $$('addResponts').getValues();
                                    // Generate current date in the required format
                                    var date =
                                        webix.Date.add(new Date(), 0, 'day').getFullYear() +
                                        ':' +
                                        ('00' + (webix.Date.add(new Date(), 0, 'day').getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + webix.Date.add(new Date(), 0, 'day').getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + webix.Date.add(new Date(), 0, 'day').getHours()).slice(-2) +
                                        ':' +
                                        ('00' + webix.Date.add(new Date(), 0, 'day').getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + webix.Date.add(new Date(), 0, 'day').getSeconds()).slice(-2);
                                    // Check if the response field is not empty
                                    if (values.Responts !== '') {
                                        // Send the response via AJAX
                                        webix
                                            .ajax()
                                            .headers({
                                                'Content-type': 'application/json',
                                            })
                                            .post(
                                                devConfig.geturlApi() + 'Agent/RespontsRequestsAgent',
                                                '{"Id":"' +
                                                    idRequests.Id +
                                                    '", "Responts":"' +
                                                    values.Responts +
                                                    '", "CreationDate":"' +
                                                    date +
                                                    '", "Action":"' +
                                                    action +
                                                    '"}',
                                                {
                                                    // Handle error response
                                                    error: function (text, data, XmlHttpRequest) {
                                                        webix.message(_('Error! '));
                                                    },
                                                    // Handle success response
                                                    success: function (text, data, XmlHttpRequest) {
                                                        webix.message({
                                                            text: _('Respuesta Generada'),
                                                            title: _('¡Exito!'),
                                                            type: 'alert-warning',
                                                        });
                                                        // Clear and reload the grid data
                                                        grid.clearAll();
                                                        grid.load(
                                                            url + '?start=0&count=' + grid.data.$pagesize + filter,
                                                        );
                                                    },
                                                },
                                            );
                                        // Reset form values after submission
                                        $$('addResponts').setValues($$('addResponts').getCleanValues());
                                        // Close the popup window
                                        this.getTopParentView().hide();
                                    } else {
                                        // Show error message if response is empty
                                        webix.message({
                                            text: _('Envie una Respuesta'),
                                            title: _('Error!'),
                                            type: 'alert-error',
                                        });
                                    }
                                },
                            },
                        ],
                    },
                ],
            },
        });

        // Event listener for approving requests
        this.on(this.app, 'requestsApprove:id', (item) => {
            idRequests = item; // Store the request ID
            action = 'approve'; // Set action to approve
            $$('lblPopup').setValue(_('Aprobar Solicitud') + item.Id); // Update popup label
            $$('buttonResponts').setValue('Aprobar'); // Update button value
        });

        // Event listener for refusing requests
        this.on(this.app, 'requestsTorefuse:id', (item) => {
            idRequests = item; // Store the request ID
            action = 'torefuse'; // Set action to refuse
            $$('lblPopup').setValue(_('Rechazar Solicitud') + item.Id); // Update popup label
            $$('buttonResponts').setValue('Rechazar'); // Update button value
        }); // Placeholder for the initialization content
    }
}

// FILE DOCUMENTED
